module.exports = __webpack_public_path__ + "img/del.5ae19d30.jpg";